module.exports = __webpack_public_path__ + "media/images/bg_main_content-cbb2139add313b31e19d90333b2dbcd4.gif";